import { render, staticRenderFns } from "./refundReason.vue?vue&type=template&id=c5e0231c&scoped=true&lang=html&"
import script from "./refundReason.vue?vue&type=script&lang=js&"
export * from "./refundReason.vue?vue&type=script&lang=js&"
import style0 from "./refundReason.vue?vue&type=style&index=0&id=c5e0231c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e0231c",
  null
  
)

export default component.exports